import React from "react";
import ProgressiveImage from "react-progressive-graceful-image";
import { TypeAnimation } from "react-type-animation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import nboimg from "../images/nbo.jpg";
import AppHeader from './layouts/AppHeader';
import ProjectsNav from './ProjectsNav';
import StackNav from './StackNav';
import FooterNav from './FooterNav';

const Home = (props) => {


  return (
    <>


      <div id="codekali_wrapper">
                 <AppHeader/>


        <div className="container">
          <div className="card codekali-round mb-3 bg-dark">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                 
         
                  <TypeAnimation
                    className="text-white codekali-bold codekali-typing mb-3"
                    sequence={[
                      "Karibu Codekali",
                      3000,
                      "<We are developers/>",
                      3000,
                      "Based in Nairobi, Kenya",
                      3000,
                      "We build web applications,",
                      3000,
                      "Native & Hybrid Apps",
                      3000,
                      "Desktop Development...",
                      3000,
                      "Payment integrations,",
                      3000,
                      "Software Development.",
                      3000,
                      "API Development too...",
                      3000,
                      "Software Design,",
                      3000,
                      "Secure API Development...",
                      3000,
                      "Cross-Platform Development,",
                      3000,
                      "DevOps Integration",
                      3000,
                      "Realtime 24/7 Support",
                      3000,
                      "We get things done.",
                      3000,
                      "Having a project or idea?",
                      3000,
                      "Let us get started now...",
                      3000,
                    ]}
                    wrapper="span"
                    speed={50}
                    style={{  display: "inline-block" }}
                    repeat={Infinity}
                  />
                  <p className="text-white">
                    Codekali is a one stop tech point for top software
                    developers, engineers, and consultants.
                  </p>
                  <p className="text-white">
                    Top companies and start-ups choose Codekali Technologies for their mission critical software and mobile development projects.
                  </p>
                  <p className="text-white">
                    Having a project or an idea in mind?{" "}
                    <a
                      className="text-warning"
                      target="_blank"
                      rel="noreferrer"
                      href="https://wa.me/254700422699?text=Hello%20Codekali%20Developers,%20I%20would%20like%20to%20hire%20your%20development%20services%20in%20relation%20to%20the%20following:"
                    >
                      Get Started Now!
                    </a>
                  </p>
                </div>
                <div className="col-md-6 mb-3">
             
                      <ProgressiveImage
                      src={nboimg}
                      placeholder={nboimg}
                    >
                      {(src, loading) => (
                        <img
                          className={`image${
                            loading
                              ? " loading img-fluid codekali-round mb-3 w-100"
                              : " loaded img-fluid codekali-round mb-3 w-100"
                          }`}
                          src={src}
                          alt="Codekali Technologies"
                          fetchpriority="high"
                        />
                      )}
                    </ProgressiveImage>
                  <a
                    className="btn btn-outline-info btn-lg w-100 text-white codekali-round codekali-bold"
                    target="_blank"
                    rel="noreferrer"
                    href="https://wa.me/254700422699?text=Hello%20Codekali%20Developers,%20I%20would%20like%20to%20hire%20your%20development%20services%20in%20relation%20to%20the%20following:"
                  >
                    <FontAwesomeIcon icon={faWhatsapp} /> Get in Touch
                  </a>
                </div>
              </div>
            </div>
          </div>

<ProjectsNav/>
<StackNav/>

        

          <FooterNav/>

        </div>
      </div>
    </>
  );
};

export default Home;
